export const environment = {
  production: false,
  auth: {
    clientId: "de7c976a-db2c-494c-8204-70d9095c5230",
    authority: "https://login.microsoftonline.com/9dfb1a05-5f1d-449a-8960-62abcb479e7d",
    redirectUri: "https://ops-developer-terminal.iadb.org/"
  }
};
